import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Resource } from '../../shared/abstract.resource.entity';
import { Serializer } from '../../shared/serializer/serializer';
import { AppConfigService } from '../app-config/app-config.service';
import { AppInjector } from 'app/app.module';

@Injectable({
  providedIn: 'root',
})
export class AbstractHttpService<T extends Resource> {
  protected url: any;
  token: any;

  constructor(
    protected httpClient: HttpClient,
    protected endpoint: string,
    protected baseUrl: string
  ) {
    this.url = baseUrl;
    this.getToken();
  }

  public create(item: T, complement?: String): Observable<T> {
    this.getUrl();
    return this.httpClient.post<T>(`${this.url}/${this.endpoint}${complement ?? ''}`, item, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  public update(item: T): Observable<T> {
    this.getUrl();
    return this.httpClient.put<T>(`${this.url}/${this.endpoint}/${item.id}`, item, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  read(id: number): Observable<T> {
    this.getUrl();
    return this.httpClient.get(`${this.url}/${this.endpoint}/${id}`, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  list(): Observable<T[]> {
    this.getUrl();
    return this.httpClient.get(`${this.url}/${this.endpoint}`, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  delete(id: number) {
    this.getUrl();
    return this.httpClient.delete(`${this.url}/${this.endpoint}/${id}`, this.getHeaders());
  }

  customDelete(customUrl) {
    this.getUrl();
    return this.httpClient.delete(`${this.url}/${this.endpoint}/${customUrl}`, this.getHeaders());
  }

  customList(customUrl): Observable<T[]> {
    this.getUrl();
    return this.httpClient.get(`${this.url}/${this.endpoint}/${customUrl}`, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  customRead(customUrl): Observable<T> {
    this.getUrl();
    var fullPath = `/${this.endpoint}/${customUrl}`;
    fullPath = fullPath.replace('//', '/');
    return this.httpClient.get(`${this.url}${fullPath}`, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  getBase64(customUrl) {
    this.getUrl();
    return this.httpClient.get(`${this.url}/${this.endpoint}/${customUrl}` /* { headers: this.getHeaders(), responseType: 'text'} */)
    .pipe(map((data: any) => data as string));
  }

  // getConfiguration(customUrl): Observable<T[]> {
  //   this.getUrl();
  //   return this.httpClient.get(`${this.url}/${customUrl}`, this.getHeaders())
  //     .pipe(map((data: any) => data));
  // }

  // saveConfiguration(item: T): Observable<T> {
  //   this.getUrl();
  //   return this.httpClient.post<T>(`${this.url}/${this.endpoint}`, item, this.getHeaders())
  //     .pipe(map((data: any) => data));
  // }

  saveImgConfiguration(customUrl, name, type, item): Observable<T> {
    this.getUrl();
    let files = item.srcElement.files
    if (!files) {
      return
    }

    let data = {
      "patientData": {
        "uid": "",
        "firstName": "",
        "lastName": "",
        "gender": "Not Specified",
        "dateOfBirth": ""
      }
    }

    const formData: FormData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append(i.toString(), files[i], files[i].name);
    }
    formData.append("data", JSON.stringify(data));

    return this.httpClient.post<T>(`${this.url}/${customUrl}/${name}/type/${type}`, formData, this.getHeaders())
      .pipe(map((data: any) => data));
  }

  getHeaders() {
    // if (!this.token)
    this.getToken();
    return { headers: { Authorization: `Bearer ${this.token}`, "Access-Control-Allow-Origin":  "*" } };
  }

  getImageHeaders() {
    // if (!this.token)
    this.getToken();
    return { headers: { Authorization: `Bearer ${this.token}`, responseType: 'blob' } };
  }

  getUrl() {
    this.url;
  }

  getToken() {
    if (!localStorage.getItem('accessToken')) return;
    this.token = JSON.parse(localStorage.getItem('accessToken'));
    while (this.token.includes('"')) {
      this.token = this.token.replace('"', '');
    }
  }

  public updateNoId(item: T): Observable<T> {
    this.getUrl();
    return this.httpClient.put<T>(`${this.url}/${this.endpoint}`, item, this.getHeaders())
      .pipe(map((data: any) => data));
  }
  
}
